import { createSelector } from '@reduxjs/toolkit';
import { calcPaginationState } from 'utils/service';
import { AppState } from '../index';
import { defaultCrmUsersFilters } from './slice';

const selectState = (state: AppState) => state.crmUsers;

export const selectCrmUsersStatuses = createSelector(
  selectState,
  ({ isLoading, error, isInit }) => {
    return { isLoading, error, isInit };
  },
);
export const selectCrmUsersData = createSelector(selectState, ({ data }) => {
  return data;
});
export const selectCrmUsersFilters = createSelector(selectState, ({ filters }) => {
  return filters;
});
export const selectCrmUsersPagination = createSelector(selectState, ({ pagination }) => {
  return calcPaginationState(pagination);
});
export const selectCrmUsersOrderBy = createSelector(selectState, ({ orderBy }) => {
  return orderBy;
});
export const selectCrmUsersHasFilters = createSelector(selectCrmUsersFilters, (filters) => {
  return JSON.stringify(filters) !== JSON.stringify(defaultCrmUsersFilters);
});
